module.exports = __webpack_public_path__ + "media/common/icon-weather-sunny-nighttime-fb73b9f1.svg";